module.exports = __webpack_public_path__ + "img/proj_portfolio.b4024e9b.png";